var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 5.61801V4.685C13.2499 4.20069 13.1543 3.72116 12.9688 3.27381C12.7832 2.82645 12.5113 2.42008 12.1686 2.07785C11.8259 1.73563 11.4192 1.46427 10.9716 1.27933C10.524 1.09439 10.0442 0.999477 9.55994 1H4.68994C4.20564 0.999477 3.72605 1.09439 3.27844 1.27933C2.83084 1.46427 2.42399 1.73563 2.0813 2.07785C1.73861 2.42008 1.4668 2.82645 1.28125 3.27381C1.0957 3.72116 1.00013 4.20069 1 4.685V15.815C1.00013 16.2993 1.0957 16.7788 1.28125 17.2262C1.4668 17.6735 1.73861 18.08 2.0813 18.4222C2.42399 18.7644 2.83084 19.0357 3.27844 19.2207C3.72605 19.4056 4.20564 19.5005 4.68994 19.5H9.56995C10.545 19.5003 11.4803 19.1135 12.1703 18.4246C12.8603 17.7357 13.2487 16.801 13.25 15.826V14.883",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.04 10.25H8",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1099 7.33496L20.0399 10.25L17.1099 13.166",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0c454ecd0dff9932dc2a080c71fe1763.svg";
export { ForwardRef as ReactComponent };